import Vue from 'vue'
import moment from 'moment'
import States from './states.es6'
import Issues from './issues.es6'
import store from '../../../store.es6'
import i18n from '../../../i18n'

class MapServiceClass {

  getAssetAlarms (asset, alarms) {
    const assets = asset
      ? [ asset.id ].concat(asset.children.map(x => x.id))
      : []

    return alarms.filter(x => asset && asset.id && assets.includes(x.assetId))
  }

  getAssetIssues (asset) {
    const days = store.state.issues.limitDays

    return asset.issues.filter(x => !x.archivedAt && !x.closed && new Date(x.actionAt).valueOf() < moment().add(days, 'days').valueOf())
  }

  getElementByAsset (id) {
    return store.state.map.elements.filter(element => element.assetId == id)[0]
  }

  updateElementStatus (element) {
    if (!element.assetId)
      return this.setElementProperties(element, { status: States.UNKNOWN, issues: Issues.EMPTY })

    // store values
    const $assets = store.getters['map/assets']
    const $alarms = store.getters['map/alarms']

    // computed values
    const assets = this.findChildrenAssets($assets, element.assetId)
    const assetIds = assets.map(asset => asset.id)
    const alarms = $alarms.filter(alarm => assetIds.includes(alarm.assetId))

    this.setElementProperties(element, {
      status: this.getElementStatus(element, alarms),
      issues: this.getElementIssuesStatus(element, assets)
    })
  }

  setElementProperties (element, properties) {
    Object.keys(properties).forEach(property => {
      Vue.set(element, property, properties[property])
    })
  }

  getElementStatus (element, alarms) {
    if (!element.assetId)
      return States.UNKNOWN

    if (!alarms.length)
      return States.OK

    if (alarms.filter(alarm => alarm.active).length)
      return States.ERROR

    return States.WARNING
  }

  getElementIssuesStatus (element, assets) {
    const issues = assets.map(asset => this.getAssetIssues(asset).map(x => !!x.failure)).flat(2)

    if (!issues.length)
      return Issues.EMPTY

    return issues.includes(true) ? Issues.FAILURE : Issues.MAINTENANCE
  }

  findChildrenAssets(assets, rootAssetId) {
    if (!assets || !rootAssetId)
      return []

    return assets.filter(
      asset => asset.assetParentsView.ids
        .map(x => parseInt(x))
        .includes(parseInt(rootAssetId))
    )
  }

  async removeElement (element) {
    const result = await Vue.prototype.$dialog.confirm({
      title: i18n.t('map.dialogs.remove-element'),
      text: i18n.t('map.dialogs.are-you-sure-to-remove-element'),
      icon: false,
      actions: {
        true: {text: i18n.t('yes'), color: 'red'},
        false: {text: i18n.t('no'), color: 'black'}
      }
    })

    if (result) {
      store.dispatch('map/remove', element)
    }
  }

}

export const MapService = new MapServiceClass()
